import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SiteConfigProvider } from './context/SiteConfigContext';
import { EditModeProvider } from './context/EditModeContext';
import { BuilderProvider } from './context/BuilderContext';
import { ToastProvider } from './components/Toast/ToastContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Outermost on purpose: a throw inside any provider or hook is caught too. */}
    <ErrorBoundary>
      <BrowserRouter>
        <SiteConfigProvider>
          <EditModeProvider>
            <BuilderProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </BuilderProvider>
          </EditModeProvider>
        </SiteConfigProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
